module.exports = __webpack_public_path__ + "static/media/document-type.31006c74.svg";